import React, { useEffect, useState } from 'react';
import {
  Container,
  Spinner,
  Card,
  Row,
  Col,
  Button,
  OverlayTrigger,
  Tooltip,
  Modal,
  Form,
} from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import {
  Delete_Specific_Accountant_Task_Action,
  Get_All_Accountant_Task_Action,
  Update_Specific_Accountant_Task_Action,
} from '../Redux/Actions/Accountant_Tasks_Action';

// Icons
import { FaTrash, FaEdit } from 'react-icons/fa';
import { useTheme } from '@mui/material';

export const ManageAllAccountantTasks = () => {
  const theme = useTheme();
  const mode = theme.palette.mode; // جلب الوضع ال
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);

  const [selectedId, setSelectedId] = useState(null);
  const [editText, setEditText] = useState('');
  const [editDate, setEditDate] = useState('');

  const getAllTasks = async () => {
    setLoading(true);
    await dispatch(Get_All_Accountant_Task_Action());
    setLoading(false);
  };

  useEffect(() => {
    getAllTasks();
  }, []);

  const resAllTasks = useSelector((state) => state.AllTasks_Reducer.TAsk);
  const AllTasks_Array = Array.isArray(resAllTasks?.data) ? resAllTasks.data : [];

  const handleDeleteClick = (id) => {
    setSelectedId(id);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    await dispatch(Delete_Specific_Accountant_Task_Action(selectedId));
    setShowDeleteModal(false);
    getAllTasks();
  };

  const handleEditClick = (item) => {
    setSelectedId(item._id);
    setEditText(item.Task);
    setEditDate(item.date?.slice(0, 10)); // YYYY-MM-DD
    setShowEditModal(true);
  };

  const confirmEdit = async () => {
    await dispatch(
      Update_Specific_Accountant_Task_Action(selectedId, {
        Task: editText,
        date: editDate,
      }),
    );
    setShowEditModal(false);
    getAllTasks();
  };

  const handleToggleRead = async (id, newValue) => {
    await dispatch(
      Update_Specific_Accountant_Task_Action(id, {
        read: newValue,
      }),
    );
    getAllTasks();
  };

  return (
    <Container className="startpage">
      <h3 className="text-primary mb-4">📋 All Accountant Tasks & Notes</h3>

      {loading ? (
        <div className="text-center my-5">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : AllTasks_Array.length === 0 ? (
        <p className="text-muted">No tasks available.</p>
      ) : (
        <Row className="g-4 w-100">
          {AllTasks_Array.map((item) => (
            <Col md={6} lg={4} key={item._id} className="w-100">
              <Card className="shadow-sm h-100 w-100 p-3 position-relative">
                {/* ❌ علامة X لو read = true */}
                {item.read && (
                  <div
                    className="position-absolute top-50 start-50 translate-middle"
                    style={{
                      fontSize: '6rem',
                      color: 'rgba(220, 53, 69, 0.3)',
                      pointerEvents: 'none',
                      zIndex: 10,
                    }}
                  >
                    ❌
                  </div>
                )}

                {/* أيقونات التحكم */}
                <Card.Title className="d-flex justify-content-center mb-3 z-1 position-relative">
                  <div className="d-flex justify-content-center gap-3">
                    <OverlayTrigger placement="top" overlay={<Tooltip>Edit</Tooltip>}>
                      <Button variant="warning" size="sm" onClick={() => handleEditClick(item)}>
                        <FaEdit />
                      </Button>
                    </OverlayTrigger>

                    <OverlayTrigger placement="top" overlay={<Tooltip>Delete</Tooltip>}>
                      <Button
                        variant="danger"
                        size="sm"
                        onClick={() => handleDeleteClick(item._id)}
                      >
                        <FaTrash />
                      </Button>
                    </OverlayTrigger>
                  </div>
                </Card.Title>

                <hr className="mb-3" />

                <div className="position-relative z-1">
                  <p className="fw-bold mb-2">📝 {item.Task}</p>
                  <p className="mb-1">
                    <strong>📅 Date:</strong> {new Date(item.date).toLocaleDateString()}
                  </p>
                  <p className="mb-1">
                    <strong>👤 Added By:</strong> {item.Added_By?.name || 'N/A'}
                  </p>
                  <p className="mb-1">
                    <strong>📧 Email:</strong> {item.Added_By?.email || 'N/A'}
                  </p>
                  <p className="mb-0 text-muted" style={{ fontSize: '0.85rem' }}>
                    🕒 Created At: {new Date(item.createdAt).toLocaleString()}
                  </p>

                  <hr />
                  <Form.Check
                    type="switch"
                    id={`read-switch-${item._id}`}
                    label="Mark as Finished"
                    checked={item.read}
                    onChange={(e) => handleToggleRead(item._id, e.target.checked)}
                  />
                </div>
              </Card>
            </Col>
          ))}
        </Row>
      )}

      {/* 🗑️ Modal الحذف */}
      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
        <Modal.Header
          closeButton
          style={{
            color: mode === 'dark' ? '#90caf9' : '#0F7687',
            backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
          }}
        >
          <Modal.Title>❗ Confirm Deletion</Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            color: mode === 'dark' ? '#90caf9' : '#0F7687',
            backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
          }}
        >
          Are you sure you want to delete this task?
        </Modal.Body>
        <Modal.Footer
          style={{
            color: mode === 'dark' ? '#90caf9' : '#0F7687',
            backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
          }}
        >
          <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={confirmDelete}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>

      {/* 📝 Modal التعديل */}
      <Modal show={showEditModal} onHide={() => setShowEditModal(false)} centered>
        <Modal.Header
          closeButton
          style={{
            color: mode === 'dark' ? '#90caf9' : '#0F7687',
            backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
          }}
        >
          <Modal.Title>✏️ Edit Task</Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            color: mode === 'dark' ? '#90caf9' : '#0F7687',
            backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
          }}
        >
          <Form.Group className="mb-3">
            <Form.Label>Task</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={editText}
              onChange={(e) => setEditText(e.target.value)}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Date</Form.Label>
            <Form.Control
              type="date"
              value={editDate}
              onChange={(e) => setEditDate(e.target.value)}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer
          style={{
            color: mode === 'dark' ? '#90caf9' : '#0F7687',
            backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
          }}
        >
          <Button variant="secondary" onClick={() => setShowEditModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={confirmEdit} disabled={!editText || !editDate}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};
